import React, { useState } from 'react';
import './App.css';



const url = new URL(window.location.href);

const form_type = url.searchParams.get("action");
console.log(form_type);

function Header() {

  return (
    <div className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
      <div className="container">
        <a id="brand-text" className="navbar-brand" href="/">
          <img style={{ height: '35px', padding: 0, margin: 0 }} src="img/isologo-kalenis-negativo.png" alt="Kalenis LIMS-QC"/>
         </a>
      </div>
        

      </div>
  );
}

export default Header;

      {/* <nav id="main_navbar"  class="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
<div class="container">

  <a id="brand-text" class="navbar-brand" href="/">
    <img  style="height:35px;padding:0;margin:0" src="img/isologo-kalenis-negativo.png" alt="Kalenis LIMS-QC">
  </a>
  <a id="brand-logo" class="navbar-brand hidden" href="/">
    <img  style="height:35px;padding:0;margin:0" src="img/isologo-kalenis.png" alt="Kalenis LIMS-QC">
  </a>
  


  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive"
    aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarResponsive">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" href="funcionalidades-control-calidad.html">Funcionalidades</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#tarifas">Tarifas</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#contacto">Contacto</a>
      </li>
    </ul>

    <ul class="navbar-nav ml-auto">
      <!-- <li class="nav-item">
        <a class="nav-link" href="#">Sign Up</a>
      </li> -->
      <li class="nav-item">
        <a class="nav-link" href="#">Acceso Clientes</a>
      </li>
    </ul>
  </div>
</div>
</nav> */}
